import { createApiHooks } from '@apis/next/common';
import { DeliveryRequestLog } from '@models/next/DeliveryRequestLog';
import { z } from 'zod';

export const deliveryRequestLogApis = createApiHooks('/delivery-request-log', [
  {
    method: 'get',
    path: '/',
    parameters: [
      {
        type: 'Query',
        name: 'delivery_request_log_access',
        schema: z.string(),
      },
    ],
    response: DeliveryRequestLog.array(),
  },
]);

export const dashboardDeliveryRequestLogApis = createApiHooks('/dashboard/delivery-request-log', [
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: DeliveryRequestLog.array(),
  },
]);
